import { DesignTokens, Select, Button as MelcoButton } from "melco-ui";
import { useTranslation } from "react-i18next";

import { LogsTable } from "./LogsTable";
import { CenteredMessage, Breadcrumb, Crumb, TopBar, MachineLabel, ScrollableDiv, LogsTableDiv } from "./summitStyled";

const { colors } = DesignTokens;

type LogsPanelProps = {
  selectedUser: any | null;
  selectedMachine: any | null;
  filteredLogs: any[];
  logsLoading: boolean;
  statusFilter: string | undefined;
  onStatusFilterChange: (status: string | undefined) => void;
  onRefresh: () => void;
};

// WHAT: the rightmost "Step 3 — logs" column.
// WHY a dedicated component: same reasoning as MachinesPanel — this was
// previously ~70 lines inlined in SummitWorkspace's JSX. As its own
// component it only needs to know "here's a machine and some logs",
// not how either of those was fetched, which keeps it trivially
// testable (pass in props, assert on rendered output) and reusable if
// another screen ever needs a similar logs view.
export const LogsPanel: React.FC<LogsPanelProps> = ({
  selectedUser,
  selectedMachine,
  filteredLogs,
  logsLoading,
  statusFilter,
  onStatusFilterChange,
  onRefresh,
}) => {
  const { t } = useTranslation();

  if (!selectedMachine) {
    return (
      <CenteredMessage>
        {t("summit.select_machine_prompt", { defaultValue: "Select a machine to view its logs" })}
      </CenteredMessage>
    );
  }

  return (
    <>
      <Breadcrumb>
        <Crumb>
          {selectedUser?.first_name} {selectedUser?.last_name}
        </Crumb>
        <span>&rsaquo;</span>
        <Crumb>{selectedMachine?.machine_name || selectedMachine?.device_id}</Crumb>

      </Breadcrumb>

      <TopBar>
        <MachineLabel>{selectedMachine?.machine_name || selectedMachine?.device_id}</MachineLabel>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: colors.gray.middle }}>Status</span>
        <Select
          allowClear
          placeholder="All"
          style={{ width: 110 }}
          value={statusFilter}
          onChange={onStatusFilterChange}
          options={[
            { label: "Success", value: "success" },

            { label: "Error", value: "error" },
          ]}
        />
        <MelcoButton onClick={onRefresh}>
          {t("summit.buttons.refresh", { defaultValue: "Refresh" })}
        </MelcoButton>
      </TopBar>

      <LogsTable dataSource={filteredLogs} loading={logsLoading} />

    </>
  );
};
